import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ca2nclcids: FaireBrandEntity = {
  token: "b_ca2nclcids",
  type: "brand",
  name: "Oooh Yeah/Sock It Up/Oooh Geez Slippers",
  avatarUrl:
    "https://cdn.faire.com/fastly/0234a603f9350c66b51ac4f27b3d422e5f08c72eb4487d37324c88fc276e8659.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fe955b927fc65f1798f5c4ca0b22ca5ebb7d6a1d5beae5248bfdb5f502a19b86.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0234a603f9350c66b51ac4f27b3d422e5f08c72eb4487d37324c88fc276e8659.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fe955b927fc65f1798f5c4ca0b22ca5ebb7d6a1d5beae5248bfdb5f502a19b86.png",
  location: "Placentia, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 97,
  isTopShop: true,
  isInsider: true,
  description:
    "At Oooh Yeah/Sock It Up/Oooh Geez, we create socks and slippers that turn everyday essentials into bestsellers. Every design is made in-house with original art, fun sayings, and vibrant patterns that help your customers connect, smile, and come back for more.\nWe’re proud to serve hundreds of retailers across the U.S., offering products that stand out in any boutique, gift shop, or specialty store. As a brand, we value originality, reliability, and growing sustainably—with biodegradable packaging already rolling out.\nJoin the fun, stock smiles, and let’s grow together!",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:15.448Z",
    importedBy: "entity-db-cli",
  },
};
